(function () {
    'use strict';

    angular
        .module('trinetixTz', [
            'ngAnimate',
            'ui.bootstrap',
            'ngRoute',
            'toastr'
        ]);

})();

(function () {
    'use strict';

    angular
        .module('trinetixTz')
        .service('userEditDialog', function ($uibModal) {
            return function (user) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/services/dialog/userEdit/user.edit.dialog.html',
                    controller: function ($scope) {
                        $scope.userModel = angular.copy(user);
                        $scope.ok = function () {
                            angular.equals(user, $scope.userModel) ?
                                modalInstance.close() :
                                modalInstance.close($scope.userModel);
                        };
                        $scope.cancel = function () {
                            modalInstance.dismiss('cancel');
                        };
                    }
                });
                return modalInstance.result;
            }
        });

})();

(function () {
    'use strict';

    angular
        .module('trinetixTz')
        .service('confirmDialog', function ($uibModal) {
            return function (title, descr) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/services/dialog/confirm/confirm.dialog.html',
                    controller: function ($scope) {
                        $scope.title = title;
                        $scope.descr = descr;
                        $scope.ok = function () {
                            modalInstance.close();
                        };
                        $scope.cancel = function () {
                            modalInstance.dismiss('cancel');
                        };
                    }
                });
                return modalInstance.result;
            }
        });

})();

(function () {
    'use strict';

    angular
        .module('trinetixTz')
        .controller('userGridCtrl', MainController);

    function MainController($scope, $http, toastr, $filter, confirmDialog, userEditDialog) {

        $scope.limit = '10';
        $scope.currentPage = '1';
        $scope.ageRange = 'all';
        $scope.userModel = [];
        $scope.isPagination = true;
        $scope.isAllSelected = false;
        $scope.checkboxes = {};
        $scope.userEdit = userEdit;
        $scope.userDelete = userDelete;
        $scope.userDeleteSelected = userDeleteSelected;
        $scope.selectUser = selectUser;

        /**
         * Change type. Pagination or Infinity scroll
         */
        var previousLimit;
        $scope.selectType = function () {
            if (!$scope.isPagination) {
                previousLimit = $scope.limit;
                $scope.limit = '25';
            } else {
                $scope.limit = previousLimit;
            }
            filterUserList();
        };

        angular.element(window).on("scroll", function () {
            if (!$scope.isPagination && $(window).scrollY + $(window).innerHeight + 150 > $(document).scrollingElement.clientHeight) {
                if ($scope.limit <= $scope.userModel.length) {
                    $scope.limit = +$scope.limit + 5;
                    filterUserList();
                    !$scope.$$phase && $scope.$apply();
                }
            }
        });

        function $(s) {
            return angular.element(s)[0];
        }

        /**
         * Getting users data
         */
        $http.get('app/userList.json').then(function (response) {
            $scope.userModel = response.data;
            filterUserList();
            $scope.loader = false;
        });
        /**
         * Watch for filter data
         */
        $scope.$watch('[currentPage, limit, sortReverse, searchTerm, ageRange]', function () {
            filterUserList();
        }, true);

        $scope.editInPlaceSave = function (arg) {
            toastr.success(arg.previousValue + ' => ' + arg.value, 'Changed');
        };

        /**
         * Edit select user in dialog window
         * @param {Object} user - User data
         */
        function userEdit(user) {
            userEditDialog(user).then(function (changedModel) {
                if (changedModel) {
                    angular.extend(user, changedModel);
                    toastr.success('Edited', 'Success');
                }
            });
        }

        /**
         * Delete select user in dialog window
         * @param {Object} user - User data
         */
        function userDelete(user) {
            var title = 'Delete user';
            var descr = 'You really want to delete ' + user.firstName + ' ' + user.lastName;
            confirmDialog(title, descr)
                .then(function () {
                    modelDeleteItem(user);
                    filterUserList();
                    toastr.success('Deleted', 'Success');
                });
        }

        /**
         * Delete selected users in dialog window
         */
        function userDeleteSelected() {
            var title = 'Delete users';
            var descr = 'You really want to delete selected users';
            confirmDialog(title, descr)
                .then(function () {
                    for (var i = 0; i < $scope.userList.length; i++) {
                        if ($scope.checkboxes[$scope.userList[i].id]) {
                            modelDeleteItem($scope.userList[i]);
                        }
                    }
                    filterUserList();
                    $scope.isAllSelected = false;
                    $scope.checkboxes = {};
                    toastr.success('Selected item deleted', 'Success');
                });
        }

        /**
         * Select all users using the checkboxSelect all items in page
         */
        $scope.selectAll = function () {
            if ($scope.isAllSelected) {
                angular.forEach($scope.userList, function (item) {
                    $scope.checkboxes[item.id] = $scope.isAllSelected;
                })
            } else {
                $scope.checkboxes = {};
            }
        };

        /**
         * The user's choice using checkbox
         * @param {String} id - User's id
         */
        function selectUser(id) {
            if (!$scope.checkboxes[id]) {
                delete $scope.checkboxes[id];
            } else {
                $scope.checkboxes[id] = true;
            }
        }

        /**
         * Filter for users
         * @returns {Array} {*} - Array with filtered user
         */
        function filterUserList() {
            var filteredData;
            if ($scope.ageRange) {
                var rangeArr = $scope.ageRange.split('-');
                rangeArr = rangeArr[1] ? rangeArr : $scope.ageRange.split('+');
                filteredData = $filter('rangeFilter')($scope.userModel, rangeArr[0], rangeArr[1]);
            }
            filteredData = $filter('filter')(filteredData, $scope.searchTerm);
            filteredData = $filter('orderBy')(filteredData, $scope.sortType, $scope.sortReverse);
            $scope.pagesLength = filteredData.length;
            filteredData = $filter('limitTo')(filteredData, $scope.limit, $scope.currentPage===1 ? 0 : ($scope.currentPage - 1) * $scope.limit);
            $scope.userList = filteredData;
            return $scope.userList;
        }

        $scope.isEmptyObject = function (obj) {
            return angular.equals({}, obj);
        };


        function modelDeleteItem(item) {
            $scope.userModel.splice($scope.userModel.indexOf(item), 1);

        }

    }
})();

(function () {
    'use strict';

    angular.module('trinetixTz')
        .filter('rangeFilter', function () {
            return function (items, min, max) {
                var result = [];
                min = parseInt(min);
                max = parseInt(max) || Number.MAX_VALUE;
                if (min) {
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].age >= min && items[i].age <= max) {
                            result.push(items[i]);
                        }
                    }
                    return result;
                }
                return items;
            };
        })

})();
(function () {
    'use strict';

    angular
        .module('trinetixTz')
        .directive('editInPlace', function () {
            return {
                restrict: 'A',
                scope: {
                    type: '@',
                    value: '=editInPlace',
                    onSave: '='
                },
                template: '<span ng-click="handleClick()" ng-bind="value"></span><input type="{{type || \'text\'}}" ng-model="modelCopy" style="width:100%;">',
                link: function ($scope, element) {

                    var inputChild = angular.element(element.children()[1]),
                        previousValue;
                    element.addClass('edit-in-place');
                    $scope.editing = false;

                    $scope.handleClick = function () {
                        if (!$scope.editing) {
                            $scope.beginEdit();
                        }
                    };

                    $scope.beginEdit = function () {
                        $scope.editing = true;
                        $scope.modelCopy = $scope.value;
                        previousValue = $scope.value;
                        element.addClass('active');
                        inputChild[0].focus();
                    };

                    inputChild.prop('onblur', function () {
                        if ($scope.editing) {
                            $scope.acceptEdits();
                        }
                    });

                    inputChild.prop('onkeyup', function (e) {
                        if ($scope.editing) {
                            if (e.keyCode === 13) {
                                $scope.acceptEdits();
                            }
                            else if (e.keyCode === 27) {
                                $scope.cancelEdits();
                            }
                        }
                    });

                    $scope.acceptEdits = function () {
                        $scope.value = $scope.modelCopy;
                        $scope.$apply();
                        if ($scope.editing) {
                            $scope.editing = false;
                            element.removeClass('active');
                            if ($scope.modelCopy !== previousValue) {
                                $scope.onSave({value: $scope.modelCopy, previousValue: previousValue});
                            }
                        }
                    };

                }
            };
        });
})();

(function () {
    "use strict";

    angular.module('trinetixTz')
        .config(function ($routeProvider) {
            $routeProvider
                .when("/", {
                    templateUrl: "app/components/user/user.grid.html",
                    controller: "userGridCtrl"
                })
                .otherwise({
                    redirectTo: '/'
                });
        });
})();
(function () {
    'use strict';

    angular
        .module('trinetixTz')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope) {
        $rootScope.loader = true;
    }

})();

(function () {
    'use strict';

    angular
        .module('trinetixTz')
        .config(config);

    /** @ngInject */
    function config(toastrConfig, $uibTooltipProvider) {
        
        // Set options third-party lib
        $uibTooltipProvider.options({popupDelay: 400});
        toastrConfig.allowHtml = true;
        toastrConfig.timeOut = 3000;
        toastrConfig.positionClass = 'toast-bottom-right';
        toastrConfig.progressBar = true;
    }

})();

angular.module("trinetixTz").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/user/user.grid.html","<div><div class=loader-container ng-show=loader><div class=loader></div></div><div class=\"jumbotron text-center\"><div class=container><div class=row><div ng-show=!isEmptyObject(checkboxes) class=pull-left style=\"padding: 20px 15px\"><button class=\"btn btn-danger btn-circle\" ng-click=userDeleteSelected() uib-tooltip=\"Remove all checked users\">Remove checked</button></div><div ng-show=isPagination><div class=pull-right><ul uib-pagination total-items=pagesLength items-per-page=limit ng-model=currentPage max-size=maxSize class=pagination-sm boundary-links=true></ul></div><div class=pull-right style=\"padding: 20px 15px\"><select ng-model=limit class=form-control><option value=5>5</option><option value=10>10</option><option value=25>25</option><option value=all>all</option></select></div></div><div class=pull-right><div class=radio style=\"margin-left: -10px\"><label><input ng-model=isPagination type=radio name=optradio checked ng-value=true ng-change=selectType()> Pagination</label></div><div class=radio><label><input ng-model=isPagination type=radio name=optradio ng-value=false ng-change=selectType()> Infinity scroll</label></div></div></div></div><div class=container><table class=\"table table-bordered table-striped\"><thead><tr><th><input type=checkbox ng-model=isAllSelected ng-change=selectAll()></th><th ng-click=\"sortType = \'id\'; sortReverse = !sortReverse\">Id <span ng-show=\"sortType == \'id\' && !sortReverse\">+</span> <span ng-show=\"sortType == \'id\' && sortReverse\">-</span></th><th ng-click=\"sortType = \'firstName\'; sortReverse = !sortReverse\">First Name <span ng-show=\"sortType == \'firstName\' && !sortReverse\">+</span> <span ng-show=\"sortType == \'firstName\' && sortReverse\">-</span></th><th ng-click=\"sortType = \'lastName\'; sortReverse = !sortReverse\">Last Name <span ng-show=\"sortType == \'lastName\' && !sortReverse\">+</span> <span ng-show=\"sortType == \'lastName\' && sortReverse\">-</span></th><th ng-click=\"sortType = \'email\'; sortReverse = !sortReverse\">Email <span ng-show=\"sortType == \'email\' && !sortReverse\">+</span> <span ng-show=\"sortType == \'email\' && sortReverse\">-</span></th><th ng-click=\"sortType = \'age\'; sortReverse = !sortReverse\">Age <span ng-show=\"sortType == \'age\' && !sortReverse\">+</span> <span ng-show=\"sortType == \'age\' && sortReverse\">-</span></th><th></th></tr></thead><tbody><tr><td></td><td><input ng-model=searchTerm.id class=form-control></td><td><input ng-model=searchTerm.firstName class=form-control></td><td><input ng-model=searchTerm.lastName class=form-control></td><td><input ng-model=searchTerm.email class=form-control></td><td style=\"width: 120px\"><select ng-model=ageRange class=form-control><option value=10-20>10-20</option><option value=21-30>21-30</option><option value=31-40>31-40</option><option value=40+>40+</option><option value=all>all</option></select></td><td></td></tr><tr ng-repeat=\"user in userList\"><td><input type=checkbox ng-model=checkboxes[user.id] ng-change=selectUser(user.id)></td><td>{{ user.id }}</td><td><div edit-in-place=user.firstName on-save=editInPlaceSave></div></td><td><div edit-in-place=user.lastName on-save=editInPlaceSave></div></td><td><div edit-in-place=user.email on-save=editInPlaceSave></div></td><td><div edit-in-place=user.age on-save=editInPlaceSave type=number></div></td><td><button class=\"btn btn-info btn-circle\" ng-click=userEdit(user) uib-tooltip=Edit>e</button> <button class=\"btn btn-danger btn-circle\" ng-click=userDelete(user) uib-tooltip=Remove>d</button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/services/dialog/confirm/confirm.dialog.html","<div class=modal-header><h3 class=modal-title>{{title}}</h3></div><div class=modal-body>{{descr}}</div><div class=modal-footer><button class=\"btn btn-primary\" type=button ng-click=ok()>OK</button> <button class=\"btn btn-warning\" type=button ng-click=cancel()>Cancel</button></div>");
$templateCache.put("app/services/dialog/userEdit/user.edit.dialog.html","<div class=modal-header><h3 class=modal-title>Edit item</h3></div><div class=modal-body><form><div class=form-group><label for=firstName>First Name</label><input ng-model=userModel.firstName class=form-control id=firstName placeholder=\"First Name\"></div><div class=form-group><label for=lastName>Last Name</label><input ng-model=userModel.lastName class=form-control id=lastName placeholder=\"Last Name\"></div><div class=form-group><label for=email>Email address</label><input ng-model=userModel.email class=form-control id=email placeholder=Email></div><div class=form-group><label for=age>Age</label><input ng-model=userModel.age class=form-control id=age placeholder=Age type=number></div></form></div><div class=modal-footer><button class=\"btn btn-primary\" type=button ng-click=ok()>OK</button> <button class=\"btn btn-warning\" type=button ng-click=cancel()>Cancel</button></div>");}]);